"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formReducer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _actions = require("./actions");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var formReducer = function formReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    loanId: '',
    prefill: [],
    genericError: '',
    formFields: {
      email: {
        key: 'email',
        value: '',
        helperText: '',
        title: 'Email',
        errors: []
      },
      password: {
        key: 'password',
        value: '',
        helperText: 'For your security, your password must be 8 to 30 characters with at least one letter and one number, and no special characters except !, @, #, $ or %.',
        title: 'Password',
        errors: []
      },
      confirmPassword: {
        key: 'confirmPassword',
        value: '',
        helperText: 'For your security, your password must be 8 to 30 characters with at least one letter and one number, and no special characters except !, @, #, $ or %.',
        title: 'Confirm Password',
        errors: []
      }
    },
    currentFocus: '',
    hasAccount: false,
    navigationToNextPage: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actions.UPDATE_FORM_FIELD:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentFocus: action.payload.currentFocus,
        formFields: action.payload.formFields,
        genericError: action.payload.genericError
      });
    case _actions.VALIDATE_AND_SUBMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        navigationToNextPage: action.payload.navigationToNextPage,
        genericError: action.payload.genericError
      });
    default:
      return state;
  }
};
exports.formReducer = formReducer;
